import { render } from "./PaymentPaypal.vue?vue&type=template&id=1d73c667"
import script from "./PaymentPaypal.vue?vue&type=script&lang=js"
export * from "./PaymentPaypal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__